export const Footer = () => {
    return (
        <footer className="footer">
            <ul>
                <li>Hosting - cloudflare.com | contabo.com</li>
                <li><a href="mailto:rencontretasouris@gmail.com">rencontretasouris@gmail.com</a></li>
                <li>hubR - Frontend & Backend</li>
                <li>Apache - MySQL - PHP - Symfony - Magento - Docker - Nginx - NodeJS - ReactJS - ExpressJS</li>
            </ul>
        </footer>
    )
}

